/* author: m.adamiec@icube.pl */
(function($, throttle) {
    $.fn.icubeLazyHtml = function(initialConfig) {
        var defaultConfig = {
            src: '',
            method: 'GET',
            body: null,
            refresh: 0,
            keepDimensions: true,
            exception: '',
            trigger: '',
            triggerevent: 'click',
            singlerequest: false,
            url: false,
            allowEmptyHtml: true,
            onInit: function() {},
            beforeRequest: function() {},
            beforeRender: function() {},
            afterRender: function() {}
        };
        
        var validRequestParams = function(params) {
            return params.src !== '' && ['GET','POST','PUT'].indexOf(params.method) > -1;
        };
        
        var sendRequest = function(params) {
            return new Promise(function(resolve, reject) {
                if (validRequestParams(params)) {
                    var settings = {
                        url: params.src,
                        method: params.method,
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject('ci-ajax-tools (icubeLazyHtml): request failed.');
                        },
                        success: function(data) {
                            if (data.hasOwnProperty('html')) {
                                resolve(data);
                            } else {
                                reject('ci-ajax-tools (icubeLazyHtml): invalid response data (html does not exist).');
                            }
                        }
                    };
                    
                    if (params.body) {
                        settings.data = params.body;
                    }
                    
                    $.ajax(settings);
                } else {
                    reject('ci-ajax-tools (icubeLazyHtml): invalid request parameters.');
                }
            });
        };
        
        var render = function($el, data, config) {
            if (data.remove) {
                $el.remove();
            } else {
                config.beforeRender($el);
                
                if (config.keepDimensions && $el.width() > 0 && $el.height() > 0) {
                    $el.css({
                        'min-width': $el.width(),
                        'min-height': $el.height()
                    });
                    
                    if (!$el.data('ci-ajax-tools-resize')) {
                        $(window).one('resize', function() {
                            $el.css({
                                'min-width': "",
                                'min-height': ""
                            });
                            $el.data('ci-ajax-tools-resize', false);
                        });
                        $el.data('ci-ajax-tools-resize', true);
                    }
                }

                if (data.html || (!data.html && config.allowEmptyHtml)) {
                    $el.children().not(config.exception).remove();
                    $el.append(data.html);                   
                    config.afterRender($el);
                }
            }
        };
        
        var updateUrl = function(url) {
            if (history.pushState && url !== window.location.href) {
                history.pushState({}, "", url);
            }
        };
        
        var eventHandler = function($el, config) {
            if ($el.is(':visible')) {
                config.beforeRequest($el);
                sendRequest(config)
                    .then(function(data) {
                        render($el, data, config);
                        
                        if (config.url) {
                            updateUrl(data.url);
                        }
                    })
                    .catch(function(errorMessage) {
                        console.warn(errorMessage);
                    });
            }          
        };
        
        if (initialConfig) {
            $.extend(defaultConfig, initialConfig);
        } 
        
        return this.each(function() {
            var $el = $(this);
            var config = $.extend({}, defaultConfig, $el.data());
            var interval;
            
            config.onInit($el);
            
            /* custom event for refresh */
            $el.on('icube.lazyhtml.refresh', throttle(function(event, newConfig) {
                var configOnRefresh = $.extend({}, config, newConfig || null);

                eventHandler($el, configOnRefresh); 
            }, 500));
            
            if (config.trigger) {
                var $trigger = typeof config.trigger === 'string' ? $(config.trigger) : config.trigger;

                $trigger.on(config.triggerevent, throttle(function() {
                    eventHandler($el, config); 
                   
                    if (config.singlerequest) {
                        $trigger.off(config.triggerevent);
                    }
                }, 500));
            } else {
                config.beforeRequest($el);            
                sendRequest(config)
                    .then(function(data) {
                        render($el, data, config); 

                        if (config.refresh > 0) {
                            interval = setInterval(function() {
                                config.beforeRequest($el);
                                sendRequest(config)
                                    .then(function(data) {
                                        render($el, data, config);

                                        if (data.remove) {
                                            clearInterval(interval);
                                        }
                                    })
                                    .catch(function(errorMessage) {
                                        clearInterval(interval);
                                        console.warn(errorMessage);
                                    });
                            }, config.refresh);
                        }
                    })
                    .catch(function(errorMessage) {
                        console.warn(errorMessage);
                    });
            }
        });
    };
}(jQuery, ci_Utils.underscore_throttle));